import React from "react";
import { View } from "@react-pdf/renderer";
import { getSectionsByPlacement } from "./registry";

const RenderSections = ({
    placement,
    sectionMeta,
    supplierData,
    user,
    downloadDate,
    overviewHeader,
    statistics,
    lastActivities,
    riskMatrixData,
    isOwnCompany,
}) => {
    const sections = getSectionsByPlacement(placement, sectionMeta);

    return (
        <View>
            {sections.map((section) => {
                const SectionComponent = section.Component;

                if (!SectionComponent) {
                    return null;
                }

                return (
                    <SectionComponent
                        key={section.id}
                        meta={section}
                        supplierData={supplierData}
                        user={user}
                        downloadDate={downloadDate}
                        overviewHeader={overviewHeader}
                        statistics={statistics}
                        lastActivities={lastActivities}
                        riskMatrixData={riskMatrixData}
                        isOwnCompany={isOwnCompany}
                    />
                );
            })}
        </View>
    );
};

export default RenderSections;
export {
    SECTION_META,
    TOC_ENTRIES,
    SECTION_DEFINITIONS,
    getSectionsByPlacement,
    buildExportSectionMeta,
    buildExportTocEntries,
} from "./registry";
